<template>
  <div
    ref="cell"
    class="grid-view__cell active"
    :class="{
      editing: editing,
      invalid: editing && !valid,
    }"
    @contextmenu="stopContextIfEditing($event)"
  >
    <div v-show="!editing" class="grid-field-url">
      <img
        v-if="faviconUrl"
        class="grid-field-url__favicon"
        :src="faviconUrl"
        alt=""
        loading="lazy"
        referrerpolicy="no-referrer"
        @error="faviconError = true"
      />
      <a
        class="grid-field-url__text"
        :href="getHref(value)"
        target="_blank"
        rel="nofollow noopener noreferrer"
        ><SearchHighlightedText :text="value" :search-term="searchTerm"
      /></a>
    </div>
    <template v-if="editing">
      <input
        ref="input"
        v-model="copy"
        type="text"
        class="grid-field-text__input"
      />
      <div v-show="!valid" class="grid-view__cell-error align-right">
        {{ error }}
      </div>
    </template>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import gridFieldInput from '@baserow/modules/database/mixins/gridFieldInput'
import {
  ensureUrlProtocol,
  getFaviconUrl,
} from '@baserow/modules/core/utils/url'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { SearchHighlightedText },
  mixins: [gridField, gridFieldInput],
  data() {
    return {
      faviconError: false,
    }
  },
  computed: {
    faviconUrl() {
      if (this.faviconError) return null
      return getFaviconUrl(this.value)
    },
  },
  watch: {
    value() {
      this.faviconError = false
    },
  },
  methods: {
    afterEdit() {
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.$refs.input.selectionStart = this.$refs.input.selectionEnd = 100000
      })
    },
    getHref(value) {
      return ensureUrlProtocol(value)
    },
  },
}
</script>
